import {Event as WireEvent} from "../../_models/event";
import {IDMap, KeyMap, ModelID} from '../../_typing/generic-types';
import {ConfigColumn, EventConfigColumn} from "../../_typing/config/config-column";
import {ConstantProperty} from "../../_models/constant-property";
import {ConditionalColumn} from "../../services/conditional-formatting.service";
import {EventTypeComponentTypeUniqueMap} from "../../_models/event-type-component-type-map";

export function sortDates(a, b, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function filterOutTempEvents(allEvents: WireEvent[], changedEventIds?:ModelID[]): WireEvent[] {
    return allEvents.filter(event => !event.id.includes('temp') && (!changedEventIds?.includes(event.id)));
}

export function getColumnId(column: EventConfigColumn | ConfigColumn | ConditionalColumn): ModelID | string {
    return column.type === 'attribute' ? (column.hasOwnProperty('related_type_id') && column['related_type_id']) ? `${column['related_type_id']}:${column.id.toLowerCase()}`  : column.id.toLowerCase() :
        (column.hasOwnProperty('related_type_id') && column['related_type_id']) ? `${column['related_type_id']}:${column.id}` : column.id;
}

export function getColIds(columns: EventConfigColumn[] | ConfigColumn[]): ModelID[] | string[] {
    if (!columns?.length) return [];
    return columns.map(c => getColumnId(c));
}

export function getPropertyIds(columns: EventConfigColumn[] | ConfigColumn[], includeRelated = true): ModelID[] {
    if (!columns?.length) return [];
    let propIds = columns.filter(c => c.type === 'constant_property' && (includeRelated === false ? !c['related_type_id'] : true)) || [];
    return propIds.map(c => c.id);
}

export function getPropertyColumns(columns: EventConfigColumn[]): EventConfigColumn[] {
    return columns.filter(c => c.type === 'constant_property');
}

export function getComponentTypeIds(columns: EventConfigColumn[] | ConfigColumn[]): ModelID[] {
    return getIdsForAttributeValue(columns, 'type', 'component_type');
}

export function getRelatedComponentTypeIds(columns: EventConfigColumn[]): ModelID[] {
    if (!columns?.length) return [];
    return columns.filter(col => col.related_type === 'component_type')?.map(col => col.related_type_id);
}

export function getEventTypeIds(columns: EventConfigColumn[] | ConfigColumn[]): ModelID[] {
    return getIdsForAttributeValue(columns, 'type', 'event_type');
}

export function getAttributeIds(columns: EventConfigColumn[] | ConfigColumn[], includeRelated = true): ModelID[] {
    return getIdsForAttributeValue(columns, 'type', 'attribute', includeRelated);
}

export function getIdsForAttributeValue(columns: EventConfigColumn[] | ConfigColumn[], att: string, value: string | boolean, includeRelated = true): ModelID[] | string[] {
    if (!columns?.length) return [];
    return (columns.filter(c => c[att] === value && (includeRelated === false ? !c['related_type_id'] : true)) || []).map(c => c.type === 'attribute' ? c.id.toLowerCase() : c.id)
}

export function belongsToEventType(row: WireEvent, col_id: string, type: 'constant_property' | 'component_type',
                                   et_cp_dict?: KeyMap<string[]>, et_ct_dict?: IDMap<IDMap<EventTypeComponentTypeUniqueMap>>): boolean {
    const etId = row.relationships.event_type?.data?.id;
    if (!etId) return false;
    if ((type === 'constant_property' && et_cp_dict?.[etId]?.includes(col_id)) ||
        type === 'component_type' && et_ct_dict?.[etId]?.[col_id]) {
        return true;
    }
    return false;
}

export function isTempId(row) {
    return row.id?.includes('temp_');
}

export function checkApplyNameFormat(constantProperty: ConstantProperty): boolean {
    if (!constantProperty?.attributes) return;
    return constantProperty.attributes.name_format && constantProperty.attributes.data_type === 'string'
        && !constantProperty.attributes.is_drop_down_list && !constantProperty.attributes.is_calculation;
}
